import {
  ADD_CAR_UPLOAD_DOCUMENTS_REQUEST,
  ADD_CAR_UPLOAD_DOCUMENTS_SUCCESS,
  ADD_CAR_UPLOAD_DOCUMENTS_FAILURE,
  ADD_CAR_UPLOAD_DOCUMENTS_REMOVE,
  UPDATE_REQUIRED_DOCS_CHECK_LIST,
} from '../../types';

const initialState = {
  status: {
    isLoading: false,
    isLoaded: false,
    error: false,
    errorMessage: null,
  },
  documentUrls: {
    registrationDocument: null,
    registrationDocumentBack: null,
    driverLicenseFront: null,
    businessDocumentFront: null,
    businessDocumentBack: null,
  },
  documents: [],
  requiredDocLength: 0,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD_CAR_UPLOAD_DOCUMENTS_REQUEST:
      return {
        ...state,
        status: {
          isLoading: true,
          isLoaded: false,
          error: false,
          errorMessage: null,
        },
      };
    case ADD_CAR_UPLOAD_DOCUMENTS_SUCCESS:
      return {
        ...state,
        status: {
          isLoading: false,
          isLoaded: true,
          error: false,
          errorMessage: null,
        },
        documents: [
          ...state.documents,
          {
            ...action.payload,
            documentUrl: undefined,
          },
        ],
        documentUrls: {
          ...state.documentUrls,
          [action.payload.name]: action.payload.documentUrl,
        },
      };
    case ADD_CAR_UPLOAD_DOCUMENTS_FAILURE:
      return {
        ...state,
        status: {
          isLoading: false,
          isLoaded: true,
          error: true,
          errorMessage: action.payload || null,
        },
      };
    case ADD_CAR_UPLOAD_DOCUMENTS_REMOVE:
      return {
        ...state,
        documentUrls: {
          ...state.documentUrls,
          [action.payload]: null,
        },
        documents: state.documents.filter(document => document.name !== action.payload),
      };
    case UPDATE_REQUIRED_DOCS_CHECK_LIST:
      return {
        ...state,
        requiredDocsCheckList: action.payload || [],
      };
    default:
      return {
        ...state,
      };
  }
};
